import script from "./AppButtonNext.vue?vue&type=script&setup=true&lang=js"
export * from "./AppButtonNext.vue?vue&type=script&setup=true&lang=js"

import "./AppButtonNext.vue?vue&type=style&index=0&id=1dbb3350&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dbb3350"]])

export default __exports__